import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/pricing/index.tsx");
